<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';
	import {ref,computed,onMounted} from 'vue';
	
	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,
		//styleId: String,
		link: String,
		linkTarget: String,
		//tooltip: String,
		sortStyle: Object,
		rowValue: String,
		restApi: String,
		restApiMethod: String,
		callback: String,
		confirm: String
	});
	
	const emit = defineEmits(['emitError']);//,props.callback]);
	
	const theLink = ref(null);
	
	const {hasLink, tdStyle} = useBasePrinter(props);
	
	const hasRestApi = computed(() => {
			return  props.restApi !== null && props.restApi !== undefined;
		});
	const hasConfirm = computed(() => {
			return  props.confirm !== null && props.confirm !== undefined;
		});
	
	function rowClick(): void {
		let confirmed= !hasConfirm || confirm(props.confirm);
		if(confirmed) {
			emit("emitError","");
			fetch(props.restApi, {
			  method: props.restApiMethod,
			  headers: { 'Content-Type': 'application/json; charset=utf-8' }
			})
			.then(response => {
				if (response.ok) {
					console.log("emit callback:"+props.callback);
					emit(props.callback,props.rowValue);
				}
				else {
					console.error('Error:', response.status);
					emit("emitError","RestApi point return status:"+response.status);
				}
			})
			.catch((error) => {
			  console.error('Error:', error);
			  emit("emitError","Error to fetch restApi point");
			});
		}
	}

	
	onMounted(() => {
		if (theLink.value) {
			crm.initPreviewFor(theLink.value);
		}
	});
	
</script>
<template>
	<td :class="styleClass" :style="[sortStyle, tdStyle]">
		<a v-if="hasLink" :href="link" v-html="value" :target="linkTarget" ref="theLink"></a>
		<span v-else-if="hasRestApi" class='activeclick' @click='rowClick' v-html="value" ></span>
		<span v-else v-html="value"></span>
	</td>
</template>

